/* MPerformance.parts — Theme JS */

const menuToggle = document.getElementById('menu-toggle');
const mobileNav = document.getElementById('mobile-nav');
const mobileNavClose = document.getElementById('mobile-nav-close');
const mobileNavOverlay = document.getElementById('mobile-nav-overlay');
menuToggle?.addEventListener('click', () => mobileNav?.classList.add('is-open'));
mobileNavClose?.addEventListener('click', () => mobileNav?.classList.remove('is-open'));
mobileNavOverlay?.addEventListener('click', () => mobileNav?.classList.remove('is-open'));

document.querySelectorAll('.accordion-btn').forEach((button) => {
  button.addEventListener('click', () => {
    const panel = button.nextElementSibling;
    const opening = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(opening));
    button.classList.toggle('open', opening);
    panel?.classList.toggle('open', opening);
  });
});

document.querySelectorAll('[data-tab-container]').forEach((container) => {
  const buttons = container.querySelectorAll('.tab-btn, .tab-nav-btn');
  const panes = container.querySelectorAll('.tab-pane');
  buttons.forEach((button) => button.addEventListener('click', () => {
    buttons.forEach((item) => item.classList.remove('active'));
    panes.forEach((item) => item.classList.remove('active'));
    button.classList.add('active');
    container.querySelector(`[data-tab-pane="${button.dataset.tab}"]`)?.classList.add('active');
  }));
});

const formatMoney = (cents, format) => {
  const value = (Number(cents || 0) / 100).toFixed(2);
  if (!format) return `$${value}`;
  return format.replace(/\{\{\s*(amount|amount_with_comma_separator|amount_no_decimals)\s*\}\}/, (match, token) => {
    if (token === 'amount_no_decimals') return Math.round(Number(cents || 0) / 100).toLocaleString();
    if (token === 'amount_with_comma_separator') return value.replace('.', ',');
    return Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  });
};

const updateCartCount = (count) => {
  document.querySelectorAll('.site-header__cart-count, [data-cart-count]').forEach((item) => {
    item.textContent = String(count);
  });
  document.querySelectorAll('a[href="/cart"], a[href$="/cart"]').forEach((link) => {
    const badge = link.querySelector('.site-header__cart-count, [data-cart-count]');
    if (badge) badge.textContent = String(count);
  });
};

const addToCart = async ({ variantId, quantity = 1, formData = null }) => {
  let response;
  if (formData) {
    response = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } });
  } else {
    response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity }),
    });
  }
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `Cart add failed (${response.status})`);
  }
  const cart = await fetch('/cart.js').then((r) => r.json());
  updateCartCount(cart.item_count || 0);
  return cart;
};

// Product gallery + variant UI
document.querySelectorAll('[data-product-root]').forEach((root) => {
  const mainImage = root.querySelector('[data-gallery-main]');
  const dialog = root.querySelector('[data-gallery-dialog]');
  const dialogImage = root.querySelector('[data-gallery-dialog-image]');
  root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
    root.querySelectorAll('[data-gallery-thumb]').forEach((item) => { item.classList.remove('active'); item.setAttribute('aria-pressed', 'false'); });
    thumb.classList.add('active');
    thumb.setAttribute('aria-pressed', 'true');
    if (mainImage) { mainImage.src = thumb.dataset.imageSrc; mainImage.removeAttribute('srcset'); mainImage.alt = thumb.dataset.imageAlt || ''; }
    if (dialogImage) { dialogImage.src = thumb.dataset.imageSrc; dialogImage.alt = thumb.dataset.imageAlt || ''; }
  }));
  root.querySelector('[data-gallery-open]')?.addEventListener('click', () => dialog?.showModal());
  root.querySelector('[data-gallery-close]')?.addEventListener('click', () => dialog?.close());
  dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });

  const form = root.querySelector('[data-product-form]');
  const select = root.querySelector('[data-variant-select]');
  const variantsNode = root.querySelector('[data-product-variants]');
  let variants = [];
  try { variants = JSON.parse(variantsNode?.textContent || '[]'); } catch (error) { variants = []; }
  const updateVariant = () => {
    const id = select?.value || root.querySelector('[data-variant-input]')?.value;
    const variant = variants.find((item) => String(item.id) === String(id));
    if (!variant) return;
    const moneyFormat = root.dataset.moneyFormat;
    root.querySelectorAll('[data-product-price]').forEach((item) => { item.textContent = formatMoney(variant.price, moneyFormat); });
    document.querySelectorAll('[data-sticky-price]').forEach((item) => { item.textContent = formatMoney(variant.price, moneyFormat); });
    root.querySelectorAll('[data-variant-sku]').forEach((item) => { item.textContent = variant.sku || 'Not provided'; });
    root.querySelectorAll('[data-variant-title]').forEach((item) => { item.textContent = variant.title; });
    root.querySelectorAll('[data-variant-stock]').forEach((item) => { item.textContent = variant.available ? 'In stock' : 'Sold out'; });
    document.querySelectorAll('[data-sticky-stock]').forEach((item) => { item.textContent = variant.available ? 'In stock' : 'Sold out'; });
    const compare = root.querySelector('[data-product-compare]');
    const saving = root.querySelector('[data-product-saving]');
    const onSale = Number(variant.compare_at_price) > Number(variant.price);
    compare?.classList.toggle('is-hidden', !onSale);
    saving?.classList.toggle('is-hidden', !onSale);
    if (compare && onSale) compare.textContent = formatMoney(variant.compare_at_price, moneyFormat);
    if (saving && onSale) {
      const pct = Math.round((1 - (Number(variant.price)/Number(variant.compare_at_price))) * 100);
      saving.innerHTML = `<span>Save ${pct}%</span>`;
      saving.classList.remove('is-hidden');
    } else if (saving) {
      saving.classList.add('is-hidden');
      saving.innerHTML='';
    }
    const addButton = root.querySelector('[data-add-button]');
    if (addButton) addButton.disabled = !variant.available;
    const label = root.querySelector('[data-add-label]');
    if (label) label.textContent = variant.available ? 'Add to cart' : 'Sold out';
    root.querySelector('[data-parts-request]')?.classList.toggle('is-hidden', variant.available);
  };
  select?.addEventListener('change', updateVariant);
  updateVariant();
  document.querySelector('[data-sticky-add]')?.addEventListener('click', () => {
    if (form?.requestSubmit) form.requestSubmit(); else form?.querySelector('[type="submit"]')?.click();
  });
});

// Product form ATC (Ajax + hard fallback)
document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    if (event.submitter && event.submitter.closest('.shopify-payment-button')) return;
    event.preventDefault();
    const btn = form.querySelector('[data-add-button], button[type="submit"][name="add"], button[type="submit"]');
    const original = btn?.textContent || 'Add to cart';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    try {
      await addToCart({ formData: new FormData(form) });
      if (btn) btn.textContent = 'Added!';
      // Go to cart so user sees success (reliable checkout path)
      window.location.href = '/cart';
    } catch (error) {
      console.error(error);
      form.submit();
    } finally {
      setTimeout(() => { if (btn) { btn.disabled = false; btn.textContent = original; } }, 1500);
    }
  });
});

// Collection card ATC
document.querySelectorAll('.js-add-to-cart').forEach((button) => button.addEventListener('click', async (event) => {
  event.preventDefault();
  if (!button.dataset.variantId) return;
  const original = button.textContent;
  button.textContent = 'Adding…'; button.disabled = true;
  try {
    await addToCart({ variantId: button.dataset.variantId, quantity: 1 });
    button.textContent = 'Added';
  } catch (error) {
    button.textContent = 'Try again';
  }
  setTimeout(() => { button.textContent = original; button.disabled = false; }, 1600);
}));

// Recommendations
document.querySelectorAll('[data-product-recommendations]').forEach((container) => {
  if (container.querySelector('.related-section') || !container.dataset.url) return;
  fetch(container.dataset.url)
    .then((response) => response.text())
    .then((text) => {
      const html = new DOMParser().parseFromString(text, 'text/html');
      const populated = html.querySelector('[data-product-recommendations]');
      if (populated?.querySelector('.related-section')) container.innerHTML = populated.innerHTML;
    })
    .catch(() => {});
});

// Homepage first-party events only
const pushHomepageEvent = (payload) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};
document.querySelectorAll('[data-home-search]').forEach((form) => {
  form.addEventListener('submit', () => pushHomepageEvent({ event: 'homepage_search_submit' }));
});
document.querySelectorAll('[data-home-cta]').forEach((link) => {
  link.addEventListener('click', () => pushHomepageEvent({
    event: 'homepage_cta_click',
    cta_name: link.dataset.homeCta,
    destination: link.getAttribute('href')
  }));
});

document.addEventListener('click', function(event){
  var button=event.target.closest('.mobile-filter-btn');
  if(!button)return;
  var panel=document.getElementById(button.getAttribute('aria-controls'));
  if(!panel)return;
  var open=panel.classList.toggle('is-open');
  button.setAttribute('aria-expanded', open ? 'true' : 'false');
});

/* fixpack2-atc */
document.addEventListener('click', function(e){
  var btn = e.target.closest('button[name="add"], [data-add-button], [data-sticky-add]');
  if(!btn) return;
  var form = btn.closest('form');
  if(!form || !(form.action||'').includes('/cart/add')) return;
  // let sticky button trigger form requestSubmit
  if(btn.hasAttribute('data-sticky-add')){
    e.preventDefault();
    if(form.requestSubmit) form.requestSubmit(); else form.submit();
  }
}, true);
